import { NoOpRuleEvaluator, RuleParser } from "./rule";
import { Maybe } from "./util/maybe";
export var Perspective;
(function (Perspective) {
    Perspective[Perspective["Client"] = 0] = "Client";
    Perspective[Perspective["Community"] = 1] = "Community";
})(Perspective || (Perspective = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["nary"] = 0] = "nary";
    QuestionType[QuestionType["binary"] = 1] = "binary";
    QuestionType[QuestionType["number"] = 2] = "number";
    QuestionType[QuestionType["currency"] = 3] = "currency";
    QuestionType[QuestionType["text"] = 4] = "text";
    QuestionType[QuestionType["date"] = 5] = "date";
    QuestionType[QuestionType["calendarDateNoYear"] = 6] = "calendarDateNoYear";
    QuestionType[QuestionType["range"] = 7] = "range";
    QuestionType[QuestionType["region"] = 8] = "region";
    QuestionType[QuestionType["derived"] = 9] = "derived";
    QuestionType[QuestionType["user"] = 10] = "user";
    QuestionType[QuestionType["notes"] = 11] = "notes";
    QuestionType[QuestionType["textArray"] = 12] = "textArray";
    QuestionType[QuestionType["naryArray"] = 13] = "naryArray";
    QuestionType[QuestionType["customList"] = 14] = "customList";
    QuestionType[QuestionType["phone"] = 15] = "phone";
})(QuestionType || (QuestionType = {}));
export var QuestionCategories;
(function (QuestionCategories) {
    // Sort this list in the order we want to display in the custom settings dropdown
    //
    // Section the show on client and community forms
    QuestionCategories[QuestionCategories["type"] = 0] = "type";
    QuestionCategories[QuestionCategories["finance"] = 1] = "finance";
    QuestionCategories[QuestionCategories["services"] = 2] = "services";
    QuestionCategories[QuestionCategories["activity"] = 3] = "activity";
    QuestionCategories[QuestionCategories["amenity"] = 4] = "amenity";
    QuestionCategories[QuestionCategories["staff"] = 5] = "staff";
    QuestionCategories[QuestionCategories["otherDetails"] = 6] = "otherDetails";
    // Sections that show on client-only forms
    QuestionCategories[QuestionCategories["summary"] = 7] = "summary";
    QuestionCategories[QuestionCategories["socialInterests"] = 8] = "socialInterests";
    // Sections that show on community-only forms
    QuestionCategories[QuestionCategories["communityRecords"] = 9] = "communityRecords";
    // Sections that aren't yet customizable
    QuestionCategories[QuestionCategories["contract"] = 10] = "contract";
    QuestionCategories[QuestionCategories["insurance"] = 11] = "insurance";
    QuestionCategories[QuestionCategories["physician"] = 12] = "physician";
    QuestionCategories[QuestionCategories["flexible"] = 13] = "flexible";
})(QuestionCategories || (QuestionCategories = {}));
export var QuestionMatching;
(function (QuestionMatching) {
    QuestionMatching[QuestionMatching["clientsubset"] = 0] = "clientsubset";
    QuestionMatching[QuestionMatching["communitysubset"] = 1] = "communitysubset";
    QuestionMatching[QuestionMatching["none"] = 2] = "none";
    QuestionMatching[QuestionMatching["equal"] = 3] = "equal";
})(QuestionMatching || (QuestionMatching = {}));
export var InteractionType;
(function (InteractionType) {
    InteractionType[InteractionType["none"] = 0] = "none";
    InteractionType[InteractionType["binary"] = 1] = "binary";
    InteractionType[InteractionType["singleRadio"] = 2] = "singleRadio";
    InteractionType[InteractionType["single"] = 3] = "single";
    InteractionType[InteractionType["multipleDropdown"] = 4] = "multipleDropdown";
    InteractionType[InteractionType["multiple"] = 5] = "multiple";
    InteractionType[InteractionType["singleline"] = 6] = "singleline";
    InteractionType[InteractionType["multiline"] = 7] = "multiline";
    InteractionType[InteractionType["number"] = 8] = "number";
    InteractionType[InteractionType["rangeNumber"] = 9] = "rangeNumber";
    InteractionType[InteractionType["currency"] = 10] = "currency";
    InteractionType[InteractionType["rangePrice"] = 11] = "rangePrice";
    InteractionType[InteractionType["date"] = 12] = "date";
    InteractionType[InteractionType["url"] = 13] = "url";
    InteractionType[InteractionType["user"] = 14] = "user";
    InteractionType[InteractionType["phone"] = 15] = "phone";
})(InteractionType || (InteractionType = {}));
export var AnnotationType;
(function (AnnotationType) {
    AnnotationType[AnnotationType["none"] = 0] = "none";
    AnnotationType[AnnotationType["single"] = 1] = "single";
    AnnotationType[AnnotationType["perAnswer"] = 2] = "perAnswer";
})(AnnotationType || (AnnotationType = {}));
export var QuestionBehavior;
(function (QuestionBehavior) {
    QuestionBehavior[QuestionBehavior["showIfPresent"] = 0] = "showIfPresent";
    QuestionBehavior[QuestionBehavior["alwaysShow"] = 1] = "alwaysShow";
    QuestionBehavior[QuestionBehavior["alwaysHide"] = 2] = "alwaysHide";
})(QuestionBehavior || (QuestionBehavior = {}));
export var QuestionSource;
(function (QuestionSource) {
    QuestionSource["Legacy"] = "Legacy";
    QuestionSource["Entity"] = "Entity";
})(QuestionSource || (QuestionSource = {}));
export const emptyPrompt = (order, id) => {
    return {
        legacyClientTitle: "",
        id,
        legacyCommunityTitle: "",
        primaryOption: false,
        order,
        key: "",
        ignoreMatching: false,
        legacyClientAnnotation: false,
        legacyCommunityAnnotation: false,
        deleted: false,
        title: "",
        annotation: false,
    };
};
// Used to create a question that the server will accept.
export const mostlyEmptyQuestion = (order) => {
    const q = new Question();
    q.questionType = QuestionType.binary;
    q.legacyClientInteraction = InteractionType.none;
    q.legacyCommunityInteraction = InteractionType.none;
    q.category = QuestionCategories.summary;
    q.legacyClientPdfBehavior = QuestionBehavior.showIfPresent;
    q.legacyCommunityPdfBehavior = QuestionBehavior.showIfPresent;
    q.order = order || 0;
    return q;
};
export class Question {
    constructor() {
        this.id = null;
        this.tenantId = null;
        this.legacyCommunityTitle = "";
        this.legacyClientTitle = "";
        this.hint = "";
        this.questionType = QuestionType.text;
        this.category = QuestionCategories.summary;
        this.matchingCriteria = QuestionMatching.equal;
        this.legacyClientInteraction = InteractionType.single;
        this.legacyClientAnnotation = AnnotationType.none;
        this.legacyCommunityInteraction = InteractionType.single;
        this.legacyCommunityAnnotation = AnnotationType.none;
        this.prompts = [];
        this.order = 0;
        this.supportAnyAndAllSearch = true;
        this.primaryQuestion = false;
        this.legacyComparisonBehavior = QuestionBehavior.showIfPresent;
        this.legacyClientPdfBehavior = QuestionBehavior.showIfPresent;
        this.legacyCommunityPdfBehavior = QuestionBehavior.showIfPresent;
        this.legacyClientSearchBehavior = QuestionBehavior.showIfPresent;
        this.legacyCommunitySearchBehavior = QuestionBehavior.showIfPresent;
        this.legacyClientRules = new NoOpRuleEvaluator();
        this.legacyCommunityRules = new NoOpRuleEvaluator();
        this.rules = new NoOpRuleEvaluator();
        this.key = "";
        this.regionMask = [];
        this.title = null;
        this.entityType = null;
        this.interaction = InteractionType.none;
        this.annotation = AnnotationType.none;
        this.searchBehavior = QuestionBehavior.showIfPresent;
        this.source = null;
        this.editable = true;
        this.regions = [];
        this._promptCache = {};
        this._promptCachePopulated = false;
    }
    clone() {
        return Question.clone(this);
    }
    static clone(source) {
        var theClone = new Question();
        if (!source) {
            return theClone;
        }
        theClone.legacyClientTitle = source.legacyClientTitle;
        theClone.legacyCommunityTitle = source.legacyCommunityTitle;
        theClone.hint = source.hint;
        theClone.questionType = source.questionType;
        theClone.category = source.category;
        theClone.tenantId = source.tenantId;
        theClone.legacyClientInteraction = source.legacyClientInteraction;
        theClone.legacyClientAnnotation = source.legacyClientAnnotation;
        theClone.legacyCommunityInteraction = source.legacyCommunityInteraction;
        theClone.legacyCommunityAnnotation = source.legacyCommunityAnnotation;
        theClone.prompts = (source.prompts || []).slice();
        theClone.matchingCriteria = source.matchingCriteria;
        theClone.order = source.order;
        theClone.supportAnyAndAllSearch = source.supportAnyAndAllSearch;
        theClone.primaryQuestion = source.primaryQuestion;
        theClone.legacyComparisonBehavior = source.legacyComparisonBehavior;
        theClone.legacyClientPdfBehavior = source.legacyClientPdfBehavior;
        theClone.legacyCommunityPdfBehavior = source.legacyCommunityPdfBehavior;
        theClone.legacyClientSearchBehavior = source.legacyClientSearchBehavior;
        theClone.legacyCommunitySearchBehavior = source.legacyCommunitySearchBehavior;
        theClone.legacyClientRules = source.legacyClientRules;
        theClone.legacyCommunityRules = source.legacyCommunityRules;
        theClone.rules = source.rules;
        theClone.regionMask = (source.regionMask || []).slice();
        theClone.id = source.id;
        theClone.key = source.key;
        theClone.title = source.title;
        theClone.entityType = source.entityType;
        theClone.interaction = source.interaction;
        theClone.annotation = source.annotation;
        theClone.searchBehavior = source.searchBehavior;
        theClone.source = source.source;
        theClone.editable = source.editable;
        theClone.regions = (source.regions || []).slice();
        return theClone;
    }
    static load(source) {
        var theClone = new Question();
        if (!source) {
            return theClone;
        }
        var questionType = source.questionType;
        var category = source.category;
        const prompts = (source.prompts || [])
            .map((p) => ({
            id: p.id,
            legacyClientTitle: p.client,
            legacyClientAnnotation: p.clientAnnotation ?? false,
            legacyCommunityTitle: p.community,
            legacyCommunityAnnotation: p.communityAnnotation ?? false,
            ignoreMatching: p.ignoreMatching,
            key: p.key,
            order: p.order ?? 0,
            primaryOption: p.primaryOption ?? false,
            title: p.title,
            deleted: p.deleted ?? false,
            annotation: p.annotation ?? false,
        }))
            .filter((p) => !p.deleted)
            .sort((a, b) => (a.order || 0) - (b.order || 0));
        theClone.regionMask = (source.regionMask || []).slice();
        theClone.legacyClientTitle = source.clientTitle;
        theClone.legacyCommunityTitle = source.communityTitle;
        theClone.hint = source.hint;
        theClone.questionType = (parseInt(QuestionType[questionType], 10));
        theClone.category = (parseInt(QuestionCategories[category], 10));
        theClone.legacyClientInteraction = (parseInt(InteractionType[source.clientInteraction], 10));
        theClone.legacyClientAnnotation = source.clientAnnotation
            ? parseInt(AnnotationType[source.clientAnnotation], 10)
            : AnnotationType.none;
        theClone.legacyCommunityInteraction = (parseInt(InteractionType[source.communityInteraction], 10));
        theClone.legacyCommunityAnnotation = source.communityAnnotation
            ? (parseInt(AnnotationType[source.communityAnnotation], 10))
            : AnnotationType.none;
        theClone.primaryQuestion = source.primaryQuestion ?? false;
        theClone.matchingCriteria = (parseInt(QuestionMatching[source.matchingCriteria], 10));
        theClone.prompts = prompts;
        theClone.order = source.order;
        theClone.supportAnyAndAllSearch = source.supportAnyAndAllSearch;
        theClone.legacyComparisonBehavior = (parseInt(QuestionBehavior[source.comparisonBehavior], 10));
        theClone.legacyClientPdfBehavior = Maybe.fromValue(source.clientPdfBehavior)
            .map(b => parseInt(QuestionBehavior[b], 10))
            .getOrElse(QuestionBehavior.showIfPresent);
        theClone.legacyCommunityPdfBehavior = Maybe.fromValue(source.communityPdfBehavior)
            .map(b => parseInt(QuestionBehavior[b], 10))
            .getOrElse(QuestionBehavior.showIfPresent);
        theClone.legacyClientSearchBehavior = (parseInt(QuestionBehavior[source.clientSearchBehavior], 10));
        theClone.legacyCommunitySearchBehavior = (parseInt(QuestionBehavior[source.communitySearchBehavior], 10));
        theClone.searchBehavior = (parseInt(QuestionBehavior[source.searchBehavior], 10));
        theClone.legacyClientRules = RuleParser.parse(source.clientRules);
        theClone.legacyCommunityRules = RuleParser.parse(source.communityRules);
        theClone.tenantId = source.tenantId;
        theClone.id = source.id && source.id.toString();
        theClone.key = source.key;
        theClone.title = source.title;
        theClone.entityType = source.entityType;
        theClone.interaction = source.interaction
            ? parseInt(InteractionType[source.interaction], 10)
            : InteractionType.none;
        theClone.annotation = source.annotation
            ? parseInt(AnnotationType[source.annotation], 10)
            : AnnotationType.none;
        theClone.source = source.source;
        theClone.editable = source.editable;
        theClone.regions = (source.regions || []).slice();
        if (typeof source.rulesString === "string") {
            const rules = JSON.parse(source.rulesString);
            theClone.rules = RuleParser.parse(rules);
        }
        return theClone;
    }
    get asJson() {
        return {
            id: this.id,
            category: QuestionCategories[this.category],
            clientInteraction: InteractionType[this.legacyClientInteraction],
            clientAnnotation: AnnotationType[this.legacyClientAnnotation],
            clientPdfBehavior: QuestionBehavior[this.legacyClientPdfBehavior],
            clientRules: Maybe.fromValue(this.legacyClientRules)
                .map(r => r.asJson)
                .getOrElse(null),
            clientSearchBehavior: QuestionBehavior[this.legacyClientSearchBehavior],
            clientTitle: this.legacyClientTitle,
            communityInteraction: InteractionType[this.legacyCommunityInteraction],
            communityAnnotation: AnnotationType[this.legacyCommunityAnnotation],
            communityPdfBehavior: QuestionBehavior[this.legacyCommunityPdfBehavior],
            communityRules: Maybe.fromValue(this.legacyCommunityRules)
                .map(r => r.asJson)
                .getOrElse(null),
            communitySearchBehavior: QuestionBehavior[this.legacyCommunitySearchBehavior],
            communityTitle: this.legacyCommunityTitle,
            comparisonBehavior: QuestionBehavior[this.legacyComparisonBehavior],
            hint: this.hint,
            key: this.key,
            matchingCriteria: QuestionMatching[this.matchingCriteria],
            order: this.order,
            primaryQuestion: this.primaryQuestion,
            prompts: (this.prompts || []).map(p => ({
                id: p.id,
                client: p.legacyClientTitle,
                clientAnnotation: p.legacyClientAnnotation,
                community: p.legacyCommunityTitle,
                communityAnnotation: p.legacyCommunityAnnotation,
                ignoreMatching: p.ignoreMatching,
                key: p.key,
                order: p.order,
                primaryOption: p.primaryOption,
                title: p.title,
                deleted: p.deleted,
                annotation: p.annotation,
            })),
            questionType: QuestionType[this.questionType],
            regionMask: (this.regionMask || []).slice(),
            supportAnyAndAllSearch: this.supportAnyAndAllSearch,
            title: this.title,
            interaction: InteractionType[this.interaction],
            annotation: AnnotationType[this.annotation],
            entityType: this.entityType,
        };
    }
    enabled(questions, answers) {
        if (!this.rules) {
            return true;
        }
        return this.rules.evaluate(questions, answers);
    }
    isPrimaryQuestion() {
        return (this.primaryQuestion ||
            (this.prompts || []).some(prompt => prompt.primaryOption));
    }
    lookupPrompt(promptId) {
        if (!this._promptCachePopulated) {
            this.prompts.forEach(p => {
                this._promptCache[p.id] = p;
            });
        }
        return this._promptCache[promptId];
    }
}
Question.orderMultiplier = 100;
//# sourceMappingURL=question.js.map